module.exports = __webpack_public_path__ + "static/img/lable.107c4bf5.svg";